exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css"), undefined);
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/fonts.css"), undefined);

// module
exports.push([module.id, ".selectIndicators__ul__2_iYt{list-style-type:none;padding:0;font-family:Open Sans,helvetica,sans-serif;font-size:15px}.selectIndicators__categoryHeader__1lZZ_{color:#0075c9;font-family:Open Sans,helvetica,sans-serif;font-size:28px;font-weight:800;line-height:30px;margin:10px 0 5px}.selectIndicators__subCategoryHeader__2BNtY{color:#000;font-family:Open Sans,helvetica,sans-serif;font-size:20px;font-weight:400}.selectIndicators__indicators__1TBCE{margin-bottom:0 0 15px}", ""]);

// exports
exports.locals = {
	"blue": "" + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css").locals["blue"] + "",
	"fontFamily": "" + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/fonts.css").locals["fontFamily"] + "",
	"ul": "selectIndicators__ul__2_iYt",
	"categoryHeader": "selectIndicators__categoryHeader__1lZZ_",
	"subCategoryHeader": "selectIndicators__subCategoryHeader__2BNtY",
	"indicators": "selectIndicators__indicators__1TBCE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./app/components/selectIndicators/selectIndicators.css
// module id = 738
// module chunks = 0